import { DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import styles from "./dashboard.module.css";
import { ArrowLeft, X } from "react-feather";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import NumberFormat from "react-number-format";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";

const MoneyField = (props) => {
    return (
        <NumberFormat
            prefix=""
            displayType="input"
            type="text"
            thousandSeparator={true}
            allowNegative={false}
            decimalScale={2}
            fixedDecimalScale
            {...props}
        />
    );
};

const schema = yup.object().shape({
    offer: yup.string().required("This field is Required"),
    rent_adjustment: yup.string(),
    new_rent_amount: yup.boolean().when("rent_adjustment", (rent_adjustment) => {
        if (rent_adjustment && parseInt(rent_adjustment) === 2)
            return yup.string().required("This field is Required").test("non-zero-validate", "This field should be $1 or greater.", (value) => parseInt(value) > 0);
        else
            return yup.string();
    }),
    new_security_deposit: yup.boolean().when("rent_adjustment", (rent_adjustment) => {
        if (rent_adjustment && parseInt(rent_adjustment) === 2)
            return yup.string().required("This field is Required");
        else
            return yup.string();
    }),
    lease_term: yup.boolean().when("rent_adjustment", (rent_adjustment) => {
        if (rent_adjustment && parseInt(rent_adjustment) === 2)
            return yup.string().required("This field is Required");
        else
            return yup.string();
    }),
    end_date: yup.boolean().when("rent_adjustment", (rent_adjustment) => {
        if (rent_adjustment && parseInt(rent_adjustment) === 2)
            return yup.string().required("This field is Required");
        else
            return yup.string();
    }),
    start_date: yup.boolean().when("rent_adjustment", (rent_adjustment) => {
        if (rent_adjustment && parseInt(rent_adjustment) === 2)
            return yup.string().required("This field is Required");
        else
            return yup.string();
    }),
});

const RenewalForm = ({ setOpenRenewalFormModal, showConfirmBox, selectedTenants, tenantList }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [allTemaplteList, setAllTemaplteList] = useState([]);
    const [temaplteList, setTemaplteList] = useState([]);
    const [rentAdjustment, setRentAdjustment] = useState(0);
    const [leaseEndDate, setLeaseEndDate] = useState(null);

    const { register, handleSubmit, control, errors, setValue, getValues, clearErrors } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange",
        defaultValues: {
            offer: ''
        }
    });

    useEffect(() => {
        const fetchTemplates = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/lease-renewal/template", {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setAllTemaplteList(response.data.data?.filter(i => i?.is_archived === 0));
            }).catch((error) => { });
        }
        fetchTemplates();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        let temaplteListTemp = [];

        if (selectedTenants?.length > 1) {
            temaplteListTemp = allTemaplteList?.filter(i => i?.rent_adjustment === 1);
            setValue('offer', temaplteListTemp[0]?.id);
            setValue('rent_adjustment', 1);
            setRentAdjustment(1);
        } else {
            temaplteListTemp = [...allTemaplteList];
        }

        setTemaplteList(temaplteListTemp);
    }, [allTemaplteList, selectedTenants]);

    useEffect(() => {
        if (selectedTenants.length === 1 && tenantList.length > 0) {
            let newTenantList = tenantList?.filter(i => i?.id === selectedTenants[0]);

            if (newTenantList.length > 0) {
                setLeaseEndDate(newTenantList[0]?.lease_end_date);
            }
        } else {
            setLeaseEndDate(null);
        }
    }, [selectedTenants, tenantList]);

    const onSubmit = async (data) => {
        if (parseInt(data?.rent_adjustment) === 1) {
            data = { ...data, new_rent_amount: 0, new_security_deposit: 0, lease_term: '1 Year', start_date: null, end_date: null }
        }
        if (parseInt(data?.rent_adjustment) === 2) {
            data = { ...data, new_rent_amount: data?.new_rent_amount?.replace(/,/g, ""), new_security_deposit: data?.new_security_deposit?.replace(/,/g, ""), start_date: dayjs(data.start_date).format("YYYY-MM-DD"), end_date: dayjs(data.end_date).format("YYYY-MM-DD") }
        }

        showConfirmBox(data);
    }

    return (<>
        <DialogTitle id="alert-dialog-title">
            <button className={`${styles.BackAddBU}`} onClick={(e) => setOpenRenewalFormModal(false)}><ArrowLeft /></button>
            <span>Send Renewal Offer</span>
            <button onClick={(e) => setOpenRenewalFormModal(false)}><X /></button>
        </DialogTitle>
        <DialogContent>
            <div className={`${styles.ProfileCardEditSec}`}>
                <p className={`${styles.OfferTemplatePopupText}`}>You’re about to send a renewal offer to the selected tenants. Choose an offer template and review the details before sending.</p>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <input type="hidden" name="rent_adjustment" ref={register} />
                        <div className={`${styles.ProfileEditFormSec}`}>
                            <div className={`${styles.EditFormFullSec} FormGroup`}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Choose Offer Template*</InputLabel>
                                    <Controller
                                        name="offer"
                                        control={control}
                                        render={(field) => (
                                            <Select
                                                {...field}
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                label="Choose Offer Template*"
                                                onChange={(e) => {
                                                    field.onChange(e);

                                                    let selOffer = temaplteList?.filter(i => i?.id === e.target.value);
                                                    if (selOffer.length) {
                                                        setRentAdjustment(selOffer[0]?.rent_adjustment);
                                                        setValue('rent_adjustment', selOffer[0]?.rent_adjustment);
                                                    }

                                                }}
                                            >
                                                {temaplteList?.map(i => {
                                                    return <MenuItem value={i?.id}>{i?.title}</MenuItem>
                                                })}
                                            </Select>
                                        )}
                                    />
                                </FormControl>
                                {errors.offer && (<p className={`${styles.ErrorM}`}>{errors.offer.message}</p>)}
                                {rentAdjustment === 1 && <p className={`${styles.HelpTextFormField}`}>Tenants will retain their existing rent with no changes.</p>}
                                {rentAdjustment === 2 && <p className={`${styles.HelpTextFormField}`}>Set a new rent amount for the selected tenants.</p>}
                                {leaseEndDate && <p className={`${styles.HelpTextFormField}`}>{dayjs(leaseEndDate).isBefore(dayjs(), 'day') ? 'The current lease expired on ' + dayjs(leaseEndDate).format('MMM D, YYYY') + '.' : 'The current lease will expire on ' + dayjs(leaseEndDate).format('MMM D, YYYY') + '.'}</p>}
                            </div>
                            {rentAdjustment === 2 && <>
                                <div className={`${styles.EditFormFullSec} FormGroup`}>
                                    <FormControl fullWidth>
                                        <InputLabel>Lease term*</InputLabel>
                                        <Controller
                                            name="lease_term"
                                            control={control}
                                            render={(field) => (<Select
                                                {...field}
                                                label="Lease term*"
                                                onChange={(e) => {
                                                    field.onChange(e);

                                                    clearErrors();

                                                    console.log(e);

                                                    if (e.target.value === "Month To Month" && getValues("start_date")) {
                                                        setValue("end_date", dayjs(getValues("start_date")).add(1, "month").subtract(1, "day"));
                                                    }
                                                    if (e.target.value === "6 Months" && getValues("start_date")) {
                                                        setValue("end_date", dayjs(getValues("start_date")).add(6, "months").subtract(1, "day"));
                                                    }
                                                    if (e.target.value === "1 Year" && getValues("start_date")) {
                                                        setValue("end_date", dayjs(getValues("start_date")).add(1, "year").subtract(1, "day"));
                                                    }
                                                }}
                                            >
                                                <MenuItem value="Month To Month">Month To Month</MenuItem>
                                                <MenuItem value="6 Months">6 Months</MenuItem>
                                                <MenuItem value="1 Year">1 Year</MenuItem>
                                            </Select>)}
                                        />
                                    </FormControl>
                                    {errors.lease_term && (<p className={`${styles.ErrorM}`}>{errors.lease_term.message}</p>)}
                                </div>
                                <div className={`${styles.EditFormHalfSec} FormGroup`}>
                                    <Controller
                                        name="new_rent_amount"
                                        control={control}
                                        render={(props) => (
                                            <TextField
                                                {...props}
                                                id="outlined-basic"
                                                label="New Rent Amount*"
                                                InputProps={{ inputComponent: MoneyField }}
                                            />
                                        )}
                                    />
                                    {errors.new_rent_amount && (<p className={`${styles.ErrorM}`}>{errors.new_rent_amount.message}</p>)}
                                </div>
                                <div className={`${styles.EditFormHalfSec} FormGroup`}>
                                    <Controller
                                        name="new_security_deposit"
                                        control={control}
                                        render={(props) => (
                                            <TextField
                                                {...props}
                                                id="outlined-basic"
                                                label="Additional Security Deposit*"
                                                InputProps={{ inputComponent: MoneyField }}
                                            />
                                        )}
                                    />
                                    {errors.new_security_deposit && (<p className={`${styles.ErrorM}`}>{errors.new_security_deposit.message}</p>)}
                                </div>
                                <div className={`${styles.EditFormHalfSec} FormGroup`}>
                                    <Controller
                                        name="start_date"
                                        control={control}
                                        render={(field) => (<DatePicker
                                            {...field}
                                            label="Lease start date*"
                                            renderInput={(params) => (<TextField {...params} />)}
                                            onChange={(e) => {
                                                field.onChange(e);

                                                clearErrors();

                                                if (getValues("lease_term") === "Month To Month") {
                                                    setValue("end_date", dayjs(e).add(1, "month").subtract(1, "day"));
                                                }
                                                if (getValues("lease_term") === "6 Months") {
                                                    setValue("end_date", dayjs(e).add(6, "months").subtract(1, "day"));
                                                }
                                                if (getValues("lease_term") === "1 Year") {
                                                    setValue("end_date", dayjs(e).add(1, "year").subtract(1, "day"));
                                                }
                                            }}
                                        />)}
                                    />
                                    {errors.start_date && (<p className={`${styles.ErrorM}`}>{errors.start_date.message}</p>)}
                                </div>
                                <div className={`${styles.EditFormHalfSec} FormGroup`}>
                                    <Controller
                                        name="end_date"
                                        control={control}
                                        render={(field) => (<DatePicker
                                            {...field}
                                            label="Lease end date*"
                                            renderInput={(params) => (<TextField {...params} />)}
                                            onChange={(e) => {
                                                field.onChange(e);

                                                clearErrors();

                                                if (getValues("lease_term") === "Month To Month") {
                                                    setValue("start_date", dayjs(e).subtract(1, "month").add(1, "day"));
                                                }

                                                if (getValues("lease_term") === "6 Months") {
                                                    setValue("start_date", dayjs(e).subtract(6, "months").add(1, "day"));
                                                }

                                                if (getValues("lease_term") === "1 Year") {
                                                    setValue("start_date", dayjs(e).subtract(1, "year").add(1, "day"));
                                                }
                                            }}
                                        />)}
                                    />
                                    {errors.end_date && (<p className={`${styles.ErrorM}`}>{errors.end_date.message}</p>)}
                                </div>
                            </>}
                        </div>
                        <div className={`${styles.ButtonArea}`}>
                            <button className={`${styles.ButtonVoiletLine}`} type="button" onClick={(e) => setOpenRenewalFormModal(false)}>Cancel</button>
                            <button className={`${styles.ButtonVoiletSolid}`} type="submit">Send</button>
                        </div>
                    </LocalizationProvider>
                </form>
            </div >
        </DialogContent >
    </>)
}


export default RenewalForm;